<template>
  <section class="hero" data-aos="fade-up">
    <div class="hero-grid">
      <!-- Lado esquerdo: texto -->
      <div class="hero-left">
        <p class="hero-kicker">DESENVOLVEDOR WEB · FREELANCER</p>

        <h1 class="hero-title">
          Construindo soluções
          <span>web modernas</span>
          para o seu negócio.
        </h1>

        <p class="hero-subtitle">
          Sou <strong>Leandro Vinícius do Prado</strong>, desenvolvedor web focado
          em Vue.js, C#, PHP, integrações e automações. Transformo processos
          manuais em sistemas simples, eficientes e prontos para crescer.
        </p>

        <div class="hero-cta">
          <router-link to="/projetos" class="btn btn-primary">
            Ver projetos em produção
          </router-link>
          <router-link to="/contato" class="btn btn-ghost">
            Falar sobre um projeto
          </router-link>
        </div>

        <div class="hero-tags">
          <span>Vue.js</span>
          <span>C# / .NET</span>
          <span>PHP</span>
          <span>API / Integrações</span>
          <span>SQL</span>
        </div>
      </div>

      <!-- Lado direito: card "tech" -->
      <div class="hero-right" data-aos="fade-left" data-aos-delay="150">
        <div class="hero-card">
          <div class="hero-card-header">
            <span class="hero-dot red"></span>
            <span class="hero-dot yellow"></span>
            <span class="hero-dot green"></span>
            <span class="hero-card-label">stack-atual.prado</span>
          </div>

          <div class="hero-card-body">
            <div class="hero-line">
              <span class="hero-key">Frontend</span>
              <span class="hero-value">Vue.js · SPA · UI responsiva</span>
            </div>
            <div class="hero-line">
              <span class="hero-key">Backend</span>
              <span class="hero-value">C# / .NET · PHP · REST APIs</span>
            </div>
            <div class="hero-line">
              <span class="hero-key">Banco de dados</span>
              <span class="hero-value">SQL Server · MySQL</span>
            </div>
            <div class="hero-line">
              <span class="hero-key">Integrações</span>
              <span class="hero-value">
                Bancárias (Santander, Bradesco) · NFe · WhatsApp
              </span>
            </div>
          </div>

          <div class="hero-card-footer">
            <span class="hero-status-dot"></span>
            <span class="hero-status-text">Disponível para novos projetos</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { onMounted } from "vue";
import { gsap } from "gsap";

onMounted(() => {
  const tl = gsap.timeline();
  tl.from(".hero-kicker", {
    opacity: 0,
    y: 12,
    duration: 0.45,
  })
    .from(
      ".hero-title",
      {
        opacity: 0,
        y: 24,
        duration: 0.6,
      },
      "-=0.1"
    )
    .from(
      ".hero-subtitle",
      {
        opacity: 0,
        y: 16,
        duration: 0.55,
      },
      "-=0.2"
    )
    .from(
      ".hero-cta .btn",
      {
        opacity: 0,
        y: 16,
        duration: 0.5,
        stagger: 0.12,
      },
      "-=0.25"
    )
    .from(
      ".hero-tags span",
      {
        opacity: 0,
        y: 10,
        duration: 0.4,
        stagger: 0.08,
      },
      "-=0.35"
    );
});
</script>

<style scoped>
.hero {
  padding: 2.5rem 0 3.5rem;
}

.hero-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) minmax(0, 1.2fr);
  gap: 3rem;
  align-items: center;
}

/* Texto à esquerda */
.hero-kicker {
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.22em;
  color: var(--pw-accent);
  margin-bottom: 0.75rem;
}

.hero-title {
  font-size: clamp(2.1rem, 3vw + 1rem, 3rem);
  line-height: 1.1;
  margin: 0 0 1rem;
}

.hero-title span {
  display: block;
  background: linear-gradient(to right, #22d3ee, #8b5cf6);
  -webkit-background-clip: text;
  color: transparent;
}

.hero-subtitle {
  margin: 0 0 1.5rem;
  color: var(--pw-muted);
  font-size: 0.98rem;
  max-width: 32rem;
}

.hero-subtitle strong {
  color: #e5e7eb;
}

.hero-cta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.85rem;
  margin-bottom: 1.4rem;
}

/* Botões */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.7rem 1.4rem;
  border-radius: 999px;
  font-size: 0.9rem;
  font-weight: 500;
  text-decoration: none;
  border: 1px solid transparent;
  cursor: pointer;
  transition:
    transform 0.15s ease-out,
    box-shadow 0.15s ease-out,
    background 0.15s ease-out,
    border-color 0.15s ease-out,
    color 0.15s ease-out;
}

.btn-primary {
  background: linear-gradient(135deg, #22d3ee, #8b5cf6);
  color: #0f172a;
  box-shadow: 0 18px 35px rgba(56, 189, 248, 0.6);
}

.btn-primary:hover {
  transform: translateY(-1px) scale(1.01);
  box-shadow: 0 25px 45px rgba(56, 189, 248, 0.85);
}

.btn-ghost {
  background: rgba(15, 23, 42, 0.7);
  border-color: rgba(148, 163, 184, 0.5);
  color: #e5e7eb;
}

.btn-ghost:hover {
  background: linear-gradient(
    to right,
    rgba(34, 211, 238, 0.08),
    rgba(139, 92, 246, 0.35)
  );
  border-color: rgba(129, 140, 248, 0.85);
}

/* Tags de tecnologia */
.hero-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.hero-tags span {
  font-size: 0.78rem;
  padding: 0.25rem 0.7rem;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: radial-gradient(
    circle at 0 0,
    rgba(34, 211, 238, 0.14),
    transparent 55%
  );
  color: rgba(209, 213, 219, 0.95);
}

/* Card tech à direita */
.hero-right {
  display: flex;
  justify-content: flex-end;
}

.hero-card {
  width: 100%;
  max-width: 360px;
  border-radius: var(--pw-radius-xl);
  background: radial-gradient(circle at 0 0, #1e293b, #020617);
  border: 1px solid rgba(148, 163, 184, 0.35);
  box-shadow: var(--pw-shadow-soft);
  overflow: hidden;
  position: relative;
}

.hero-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background: conic-gradient(
    from 180deg at 50% 50%,
    rgba(34, 211, 238, 0.1),
    transparent 35%,
    rgba(139, 92, 246, 0.15),
    transparent 75%
  );
  opacity: 0.55;
  mix-blend-mode: soft-light;
  pointer-events: none;
}

.hero-card-header {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.55rem 0.8rem;
  border-bottom: 1px solid rgba(51, 65, 85, 0.9);
  background: linear-gradient(to right, #020617, #020617, #111827);
}

.hero-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
}

.hero-dot.red {
  background: #f97373;
}

.hero-dot.yellow {
  background: #fbbf24;
}

.hero-dot.green {
  background: #22c55e;
}

.hero-card-label {
  margin-left: auto;
  font-size: 0.7rem;
  color: rgba(148, 163, 184, 0.85);
}

.hero-card-body {
  position: relative;
  padding: 0.85rem 1rem 0.4rem;
  font-family: "JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, Monaco,
    Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 0.78rem;
}

.hero-line {
  display: flex;
  gap: 0.6rem;
  margin-bottom: 0.25rem;
}

.hero-key {
  min-width: 6.1rem;
  color: rgba(148, 163, 184, 0.95);
}

.hero-value {
  color: rgba(226, 232, 240, 0.96);
}

.hero-card-footer {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.7rem 1rem 0.8rem;
  border-top: 1px solid rgba(51, 65, 85, 0.9);
  background: linear-gradient(to right, #020617, #0b1120);
  font-size: 0.75rem;
  color: rgba(190, 242, 100, 0.95);
}

.hero-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #22c55e;
  box-shadow: 0 0 14px rgba(34, 197, 94, 0.9);
}

/* Responsivo */
@media (max-width: 960px) {
  .hero-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 2.5rem;
  }

  .hero-right {
    justify-content: flex-start;
  }
}

@media (max-width: 640px) {
  .hero {
    padding-top: 1.2rem;
  }

  .hero-title {
    font-size: 1.9rem;
  }

  .hero-card {
    max-width: 100%;
  }
}
</style>
